












































































































































































import {Component, Vue, Prop} from "vue-property-decorator";
import * as Resource from "../../api/Resource";
import {mapActions} from "vuex";
import {TogglePayload} from "../../store/modules/app/state";
import {Instance} from "../../api/config/Users";

@Component({
  methods: {
    ...mapActions("app", ["toggleGlobalSnackBar"]),
  },
})
export default class CreateUser extends Vue {
  @Prop() payload!: Instance;
  email = "";
  loading = false;
  toggleGlobalSnackBar!: (payload: TogglePayload) => void;
  updatedItem: any = {};

  activePicker = null;
  dateOfBirthMenu = false;

  userCred = {
    displayName: "",
    phone: "",
    email: "",
    role: "",
    birthDate: null,
    profilePhotoUrl: "",
    isBanned: false,
    isInvited: false,
    emailVerified: false,
    enableDiscountsSms: true,
    enableRemindersSms: true,
    enablePromotionsSms: true,
    enableDiscountsEmail: true,
    enableRemindersEmail: true,
    enablePromotionsEmail: true,
    enableNewsAndUpdateSms: true,
    enableNewsAndUpdateEmail: true,
    // @ts-ignore
    ...this.$route.params.payload,
  };
  checkBoxFields1 = {};
  checkBoxFields2 = {};
  roleSelectItems = ["user", "admin"];

  created() {
    this.updatedItem = this.$route.params?.payload || {};
    this.checkBoxFields1 = {
      isBanned: {
        value: this.updatedItem?.isBanned,
        label: "isBanned",
      },
      isInvited: {
        value: this.updatedItem?.isInvited,
        label: "isInvited",
      },
    };

    this.checkBoxFields2 = {
      emailVerified: {
        value: this.updatedItem?.emailVerified,
        label: "emailVerified",
      },
      enableDiscountsSms: {
        value: this.$route.params?.enableDiscountsSms,
        label: "enableDiscountsSms",
      },
      enableRemindersSms: {
        value: this.$route.params?.enableRemindersSms,
        label: "enableRemindersSms",
      },
      enablePromotionsSms: {
        value: this.updatedItem?.enablePromotionsSms,
        label: "enablePromotionsSms",
      },
      enableDiscountsEmail: {
        value: this.updatedItem?.enableDiscountsEmail,
        label: "enableDiscountsEmail",
      },
      enableRemindersEmail: {
        value: this.updatedItem?.enableRemindersEmail,
        label: "enableRemindersEmail",
      },
      enablePromotionsEmail: {
        value: this.updatedItem?.enablePromotionsEmail,
        label: "enablePromotionsEmail",
      },
      enableNewsAndUpdateSms: {
        value: this.updatedItem?.enableNewsAndUpdateSms,
        label: "enableNewsAndUpdateSms",
      },
      enableNewsAndUpdateEmail: {
        value: this.updatedItem?.enableNewsAndUpdateEmail,
        label: "enableNewsAndUpdateEmail",
      },
    };
  }

  goBack() {
    this.$router.back();
  }

  save() {
    this.dateOfBirthMenu = false;
  }

  submit() {
    this.loading = true;

    (
      this.$refs.loginObserver as Vue & {
        validate: () => any;
      }
    )
      .validate()
      .then(async (isValid: boolean) => {
        if (isValid) {
          console.log("FORM DATA: ", this.userCred);
          try {
            if (this.userCred) {
              const payload: any = this.$route.params.payload; 
              // @ts-ignore
              const user = await Resource.users
                .updateUser(payload?.id || "")
                .pipe(this.userCred);
              this.loading = false;
              this.toggleGlobalSnackBar({
                show: true,
                type: "success",
                text: "User updated successfully!",
              });
              this.goBack();
            }
          } catch (e) {
            this.loading = false;
            console.log(e);
            this.toggleGlobalSnackBar({
              show: true,
              type: "error",
              text: "Error occured please try again!",
            });
          }
        } else {
          this.loading = false;
        }
      })
      .catch((error: any) => {
        setTimeout(() => (this.loading = false), 2000);
      });
  }
}
